
export const interestRateTypeList = [
  { name: "Fixed", value: "53669856-4681-11e9-82f6-0242ac120002" },
  { name: "Floating", value: "5813c493-4681-11e9-82f6-0242ac120002" }
];
export default {
  FIXED: "53669856-4681-11e9-82f6-0242ac120002",
  FLOATING: "5813c493-4681-11e9-82f6-0242ac120002"
};
